module.exports = __webpack_public_path__ + "img/call_history.e92fc994.svg";